import { 
	SEND_EMAIL_TO_PRODUCER
} from "./Constants"

export const sendEmailToProducer = (dispatch, params) => {
  dispatch({ type: SEND_EMAIL_TO_PRODUCER, payload: { body: params } })
}